module.exports = __webpack_public_path__ + "img/step3.64e69c5d.png";